import { render, staticRenderFns } from "./SalesLeaveChangeModal.vue?vue&type=template&id=51b5f7f6&scoped=true&"
import script from "./SalesLeaveChangeModal.vue?vue&type=script&lang=js&"
export * from "./SalesLeaveChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeaveChangeModal.vue?vue&type=style&index=0&id=51b5f7f6&prod&lang=scss&"
import style1 from "./SalesLeaveChangeModal.vue?vue&type=style&index=1&id=51b5f7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5f7f6",
  null
  
)

export default component.exports